export default __webpack_public_path__ + "static/media/other.a3ceee94.svg";